import { message } from 'antd';
import { call, put, takeEvery, all, fork, takeLatest } from 'redux-saga/effects'
import { getAllLoggedInUsers } from '../../../services/users-service';
import { FETCH_LOGGED_IN_USERS, FETCH_LOGGED_IN_USERS_ERROR, FETCH_LOGGED_IN_USERS_START, FETCH_LOGGED_IN_USERS_SUCCESS, sortLoggedInUsers } from '../../actions/admin/loggedInUsersActions';

function* fetchLoggedInUsers() {
    try {
        yield put({ type: FETCH_LOGGED_IN_USERS_START })
        const response = yield call(getAllLoggedInUsers);
        if (response.success) {
            const sortedUsers = sortLoggedInUsers(response.users);
            yield put({ type: FETCH_LOGGED_IN_USERS_SUCCESS, users: sortedUsers })
        } else {
            yield put({ type: FETCH_LOGGED_IN_USERS_ERROR, error: response.error })
            message.error('Failed to fetch logged in users!');
        }
    } catch (error) {
        yield put({ type: FETCH_LOGGED_IN_USERS_ERROR, error })
        message.error('Failed to fetch logged in users!');
    }
}


function* loggedInUsersWatcher() {
    yield takeLatest(FETCH_LOGGED_IN_USERS, fetchLoggedInUsers)
}

export default function* rootSaga() {
    yield all([
        loggedInUsersWatcher()
    ]);
}